<script setup lang="ts">
import { useConnectionStore } from '@/stores/connection.store'

const connectionStore = useConnectionStore()
</script>

<template>
  <Transition
    enter-active-class="transition-all duration-300 ease-out"
    enter-from-class="opacity-0 -translate-y-full"
    enter-to-class="opacity-100 translate-y-0"
    leave-active-class="transition-all duration-200 ease-in"
    leave-from-class="opacity-100 translate-y-0"
    leave-to-class="opacity-0 -translate-y-full"
  >
    <div
      v-if="connectionStore.isConnecting"
      class="fixed top-0 left-0 right-0 z-[100] flex items-center justify-center gap-3 bg-gradient-to-r from-amber-500 to-orange-500 px-4 py-2.5 text-white shadow-lg"
    >
      <!-- Spinner -->
      <svg
        class="h-5 w-5 animate-spin"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          class="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          stroke-width="4"
        />
        <path
          class="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        />
      </svg>

      <!-- Message -->
      <span class="text-sm font-medium">
        {{ connectionStore.connectionMessage }}
      </span>

      <!-- Retry indicator -->
      <span
        v-if="connectionStore.retryCount > 0"
        class="rounded-full bg-white/20 px-2 py-0.5 text-xs font-medium"
      >
        Attempt {{ connectionStore.retryCount }}/{{ connectionStore.maxRetries }}
      </span>
    </div>
  </Transition>
</template>
